import React from "react";
import MaterialIcon from "../../../../components/BuilderComponents/MaterialIcon";

const ToggleJobs = ({ handleToggleChange, toggleStates }) => {
  const toggleOptions = [
    {
      name: "Pre Activity",
      key: "pre",
      icon: "format_list_bulleted",
      label: "Pr-A"
    },
    {
      name: "Pre Submission",
      key: "pre_submission",
      icon: "order_approve",
      label: "Pr-S"
    },
    {
      name: "State Change Logic",
      key: "state",
      icon: "auto_transmission",
      label: "SCL"
    },
    {
      name: "Next Activity",
      key: "activity",
      icon: "pending_actions",
      label: "NA"
    }
  ];

  const onToggle = (job) => {
    handleToggleChange(job, !toggleStates[job]);
  };

  return (
    <div
      style={{ display: "flex", flexDirection: "row", position: "absolute", top: "16px", right: "300px", zIndex: 1 }}
    >
      <div className="sm_blueprint_functionboxOut no-select flex_row" style={{ gap: "8px" }}>
        {toggleOptions.map(({ name, key, icon, label }, index) => (
          <React.Fragment key={key}>
            <div
              onClick={() => onToggle(key)}
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                cursor: "pointer",
                gap: "4px"
              }}
              title={name}
            >
              <span style={{ fontSize: "12px" }}>{label}</span>
              <MaterialIcon
                name={icon}
                style={{
                  color: toggleStates[key] ? "#007bff" : "#10182b",
                  backgroundColor: toggleStates[key] ? "#ffffff" : "transparent"
                }}
              />
            </div>
            {index < toggleOptions.length - 1 && <hr />}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default ToggleJobs;
